import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { debounce } from '../../../../helpers/common'
import { formatVal } from '../../../../helpers/value'
import { formatParamsGetResult } from '../../common/helper'
import { selectScreeningIndicatorById } from '../../common/store/slice'
import {
  changeTotalResult,
  selectCriteria,
  selectTotalResult,
} from '../store/slice'
import { getTotalResult } from '../store/thunk'
import classes from './index.module.scss'

export const TotalResult = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const totalResult = useSelector(selectTotalResult)
  const criteria = useSelector(selectCriteria())
  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())

  const requestParams = useMemo(() => {
    return formatParamsGetResult({ criteria, screeningIndicatorById })
  }, [criteria, screeningIndicatorById])

  const handleGetTotalResult = useCallback(
    debounce((params) => {
      dispatch(getTotalResult(params))
    }, 700),
    [],
  )

  useEffect(() => {
    if (requestParams.criterias.length) {
      handleGetTotalResult(requestParams)
    } else {
      dispatch(changeTotalResult(0))
    }
  }, [JSON.stringify(requestParams)])

  return (
    <Element
      className={classes.totalResults}
      style={{ color: '#191D25', fontSize: 14 }}
    >
      <Translate
        value="screening.TOTAL_RESULT"
        count={
          !totalResult || requestParams.criterias.length === 0
            ? 0
            : formatVal(totalResult, locale, false, 0)
        }
        suffix={totalResult > 1 ? 's' : ''}
      />
    </Element>
  )
}
